const ORDER = {
  NOT_FOUND: 'Order not found.',
  DELETED: 'Order deleted.',
} as const;

export default ORDER;
